// Presentational spinner shown while AI is parsing slip screenshots
function ImportParsingState({total, preview}) {
  return (
    <div style={{textAlign:"center",padding:"40px 20px"}}>
      {preview&&<img src={preview} alt="slip" style={{width:"100%",maxHeight:220,objectFit:"contain",borderRadius:12,marginBottom:20,border:"1px solid #1e293b"}}/>}
      <div style={{width:40,height:40,border:"3px solid #1e293b",borderTopColor:"#4f46e5",borderRadius:"50%",animation:"spin 0.8s linear infinite",margin:"0 auto 16px"}}/>
      <div style={{fontSize:14,fontWeight:700,color:"#94a3b8"}}>
        {total>1?`Reading ${total} slips…`:"Reading your slip…"}
      </div>
      <div style={{fontSize:12,color:"#334155",marginTop:6}}>AI is extracting your bet details</div>
    </div>
  );
}

export default ImportParsingState;
